import { render, staticRenderFns } from "./suggest.vue?vue&type=template&id=3b720c34&"
import script from "./suggest.vue?vue&type=script&lang=js&"
export * from "./suggest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports